var React = require('react');

function Bubbles (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.8","data-name":"Gruppe 463"},[React.createElement("path",{"stroke":"#4a4aff","d":"M8.33.9h11.83a7.43 7.43 0 0 1 7.43 7.43h0a7.43 7.43 0 0 1-7.43 7.42H.9h0V8.33A7.43 7.43 0 0 1 8.33.9Z","key":0}),React.createElement("path",{"stroke":"#3b4b6f","d":"M15.12 18.2a7.43 7.43 0 0 0 7.02 4.98H41.4v-7.42a7.43 7.43 0 0 0-7.42-7.43h-3.7","key":1})]));
}

Bubbles.defaultProps = {"width":"42.3","height":"24.08"};

module.exports = Bubbles;

Bubbles.default = Bubbles;
